import { useRole } from '@ztechapps/common.hook'
import { orderPermissions } from '@ztechapps/order.common'

export const useCanEditPurchaseOrder = () => {
  const { hasRole } = useRole({ roleName: orderPermissions.canEdit.value })

  return hasRole
}
